import { Inject, Injectable, Injector } from '@angular/core';


import { MovuRobotics_TestService } from './MovuRobotics.flow.index';
import { MovuRobotics_activate_container_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_alter_pallet_hold_release_request_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_change_shipment_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_delete_configuration_by_environment_warehouseService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_activate_container_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_alter_pallet_hold_release_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_change_shipment_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_pallet_induction_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_pallet_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_pick_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_execute_shipment_download_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_get_access_tokenService } from './MovuRobotics.flow.index';
import { MovuRobotics_get_configuration_by_environment_warehouseService } from './MovuRobotics.flow.index';
import { MovuRobotics_get_instance_informationService } from './MovuRobotics.flow.index';
import { MovuRobotics_inbound_services_allocation_shortageService } from './MovuRobotics.flow.index';
import { MovuRobotics_inbound_services_pallet_arrivalService } from './MovuRobotics.flow.index';
import { MovuRobotics_inbound_services_pick_confirmationService } from './MovuRobotics.flow.index';
import { MovuRobotics_inbound_services_storage_completeService } from './MovuRobotics.flow.index';
import { MovuRobotics_main_outbound_transactions_auto_flag_for_retryService } from './MovuRobotics.flow.index';
import { MovuRobotics_main_outbound_transactions_retryService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_activate_container_request_payloadService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_activate_shipment_by_shipidsService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_alter_pallet_hold_release_request_payloadService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_change_shipment_request_payloadService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_pallet_induction_request_payloadService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_pallet_request_detailsService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_pick_request_detailsService } from './MovuRobotics.flow.index';
import { MovuRobotics_map_shipment_download_request_payloadService } from './MovuRobotics.flow.index';
import { MovuRobotics_pallet_induction_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_pallet_request_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_pick_confirmation_on_failureService } from './MovuRobotics.flow.index';
import { MovuRobotics_pick_request_on_failureService } from './MovuRobotics.flow.index';
import { MovuRobotics_pick_request_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_pick_request_processorService } from './MovuRobotics.flow.index';
import { MovuRobotics_save_configuration_by_environment_warehouseService } from './MovuRobotics.flow.index';
import { MovuRobotics_send_alert_to_footprint_legacyService } from './MovuRobotics.flow.index';
import { MovuRobotics_send_http_requestService } from './MovuRobotics.flow.index';
import { MovuRobotics_shipment_download_on_successService } from './MovuRobotics.flow.index';
import { MovuRobotics_testing_the_is_defined_functionService } from './MovuRobotics.flow.index';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public MovuRobotics: MovuRobotics_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _Test: MovuRobotics_TestService;
  public async Test($inParams: {  }): Promise< { result?: any[], totalCount?: number, debugDetails?: string[] }> {
    if(!this._Test) { 
      this._Test = this.injector.get(MovuRobotics_TestService);
    }
    return this._Test.run($inParams);
  }
   
   

   
 
  private _activate_container_on_success: MovuRobotics_activate_container_on_successService;
  public async activate_container_on_success($inParams: { loadContainerId?: number, locationId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._activate_container_on_success) { 
      this._activate_container_on_success = this.injector.get(MovuRobotics_activate_container_on_successService);
    }
    return this._activate_container_on_success.run($inParams);
  }
   
   

   
 
  private _alter_pallet_hold_release_request_on_success: MovuRobotics_alter_pallet_hold_release_request_on_successService;
  public async alter_pallet_hold_release_request_on_success($inParams: { taskId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._alter_pallet_hold_release_request_on_success) { 
      this._alter_pallet_hold_release_request_on_success = this.injector.get(MovuRobotics_alter_pallet_hold_release_request_on_successService);
    }
    return this._alter_pallet_hold_release_request_on_success.run($inParams);
  }
   
   

   
 
  private _change_shipment_on_success: MovuRobotics_change_shipment_on_successService;
  public async change_shipment_on_success($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._change_shipment_on_success) { 
      this._change_shipment_on_success = this.injector.get(MovuRobotics_change_shipment_on_successService);
    }
    return this._change_shipment_on_success.run($inParams);
  }
   
   

   
 
  private _delete_configuration_by_environment_warehouse: MovuRobotics_delete_configuration_by_environment_warehouseService;
  public async delete_configuration_by_environment_warehouse($inParams: { application_name: string, environment: string, warehouseId: number, Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Auth_Authorization?: string, Auth_TokenUrl?: string, Auth_Scope?: string, Auth_GrantType?: string, Auth_ClientId?: string, Auth_ClientSecret?: string, Auth_Username?: string, Auth_Password?: string, Service_PickRequest?: string }): Promise< { Endpoint?: string, Port?: string, Username?: string, Password?: string, ApiKey?: string, ApiSecret?: string, debugDetails?: string[], Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Service_PickRequest?: string }> {
    if(!this._delete_configuration_by_environment_warehouse) { 
      this._delete_configuration_by_environment_warehouse = this.injector.get(MovuRobotics_delete_configuration_by_environment_warehouseService);
    }
    return this._delete_configuration_by_environment_warehouse.run($inParams);
  }
   
   

   
 
  private _execute_activate_container_request: MovuRobotics_execute_activate_container_requestService;
  public async execute_activate_container_request($inParams: { loadContainerId?: number, locationId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_activate_container_request) { 
      this._execute_activate_container_request = this.injector.get(MovuRobotics_execute_activate_container_requestService);
    }
    return this._execute_activate_container_request.run($inParams);
  }
   
   

   
 
  private _execute_alter_pallet_hold_release_request: MovuRobotics_execute_alter_pallet_hold_release_requestService;
  public async execute_alter_pallet_hold_release_request($inParams: { taskId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_alter_pallet_hold_release_request) { 
      this._execute_alter_pallet_hold_release_request = this.injector.get(MovuRobotics_execute_alter_pallet_hold_release_requestService);
    }
    return this._execute_alter_pallet_hold_release_request.run($inParams);
  }
   
   

   
 
  private _execute_change_shipment_request: MovuRobotics_execute_change_shipment_requestService;
  public async execute_change_shipment_request($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number, changeContext?: string }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_change_shipment_request) { 
      this._execute_change_shipment_request = this.injector.get(MovuRobotics_execute_change_shipment_requestService);
    }
    return this._execute_change_shipment_request.run($inParams);
  }
   
   

   
 
  private _execute_pallet_induction_request: MovuRobotics_execute_pallet_induction_requestService;
  public async execute_pallet_induction_request($inParams: { licensePlateId?: number, locationId?: number, warehouseId?: number, taskId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_pallet_induction_request) { 
      this._execute_pallet_induction_request = this.injector.get(MovuRobotics_execute_pallet_induction_requestService);
    }
    return this._execute_pallet_induction_request.run($inParams);
  }
   
   

   
 
  private _execute_pallet_request: MovuRobotics_execute_pallet_requestService;
  public async execute_pallet_request($inParams: { taskId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_pallet_request) { 
      this._execute_pallet_request = this.injector.get(MovuRobotics_execute_pallet_requestService);
    }
    return this._execute_pallet_request.run($inParams);
  }
   
   

   
 
  private _execute_pick_request: MovuRobotics_execute_pick_requestService;
  public async execute_pick_request($inParams: { taskId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_pick_request) { 
      this._execute_pick_request = this.injector.get(MovuRobotics_execute_pick_requestService);
    }
    return this._execute_pick_request.run($inParams);
  }
   
   

   
 
  private _execute_shipment_download_request: MovuRobotics_execute_shipment_download_requestService;
  public async execute_shipment_download_request($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._execute_shipment_download_request) { 
      this._execute_shipment_download_request = this.injector.get(MovuRobotics_execute_shipment_download_requestService);
    }
    return this._execute_shipment_download_request.run($inParams);
  }
   
   

   
 
  private _get_access_token: MovuRobotics_get_access_tokenService;
  public async get_access_token($inParams: { token_url?: string, scope?: string, grant_type?: string, client_id?: string, client_secret?: string, messageTransactionId?: string, warehouseId?: number }): Promise< { accessToken?: string, outputDetails?: string[] }> {
    if(!this._get_access_token) { 
      this._get_access_token = this.injector.get(MovuRobotics_get_access_tokenService);
    }
    return this._get_access_token.run($inParams);
  }
   
   

   
 
  private _get_configuration_by_environment_warehouse: MovuRobotics_get_configuration_by_environment_warehouseService;
  public async get_configuration_by_environment_warehouse($inParams: { application_name: string, environment: string, warehouseId: number }): Promise< { debugDetails?: string[], Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Auth_Authorization?: string, Auth_TokenUrl?: string, Auth_Scope?: string, Auth_GrantType?: string, Auth_ClientId?: string, Auth_ClientSecret?: string, Auth_Username?: string, Auth_Password?: string, Auth_AccessToken?: string, Auth_ExpiresIn?: string, Service_PickRequest?: string }> {
    if(!this._get_configuration_by_environment_warehouse) { 
      this._get_configuration_by_environment_warehouse = this.injector.get(MovuRobotics_get_configuration_by_environment_warehouseService);
    }
    return this._get_configuration_by_environment_warehouse.run($inParams);
  }
   
   

   
 
  private _get_instance_information: MovuRobotics_get_instance_informationService;
  public async get_instance_information($inParams: {  }): Promise< { application_name?: string, environment?: string, footprint_alert_topic?: string, footprint_alert_workflow_code?: string }> {
    if(!this._get_instance_information) { 
      this._get_instance_information = this.injector.get(MovuRobotics_get_instance_informationService);
    }
    return this._get_instance_information.run($inParams);
  }
   
   

   
 
  private _inbound_services_allocation_shortage: MovuRobotics_inbound_services_allocation_shortageService;
  public async inbound_services_allocation_shortage($inParams: { order_number?: string, line_number?: string, item_number?: string, requested_ship_quantity?: number, allocation_shortage_quantity?: number, shortage_reasons?: { reason?: string }[] }): Promise< { result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> {
    if(!this._inbound_services_allocation_shortage) { 
      this._inbound_services_allocation_shortage = this.injector.get(MovuRobotics_inbound_services_allocation_shortageService);
    }
    return this._inbound_services_allocation_shortage.run($inParams);
  }
   
   

   
 
  private _inbound_services_pallet_arrival: MovuRobotics_inbound_services_pallet_arrivalService;
  public async inbound_services_pallet_arrival($inParams: { pallet_id?: string, location?: string, reason_codes?: number[] }): Promise< { result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> {
    if(!this._inbound_services_pallet_arrival) { 
      this._inbound_services_pallet_arrival = this.injector.get(MovuRobotics_inbound_services_pallet_arrivalService);
    }
    return this._inbound_services_pallet_arrival.run($inParams);
  }
   
   

   
 
  private _inbound_services_pick_confirmation: MovuRobotics_inbound_services_pick_confirmationService;
  public async inbound_services_pick_confirmation($inParams: { Task_id?: string, wh_id?: string, Srcloc?: string, Pallet_id?: string, Success?: any }): Promise< { result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> {
    if(!this._inbound_services_pick_confirmation) { 
      this._inbound_services_pick_confirmation = this.injector.get(MovuRobotics_inbound_services_pick_confirmationService);
    }
    return this._inbound_services_pick_confirmation.run($inParams);
  }
   
   

   
 
  private _inbound_services_storage_complete: MovuRobotics_inbound_services_storage_completeService;
  public async inbound_services_storage_complete($inParams: { pallet_id?: string, storage_location?: string, project?: string, wh_id?: string }): Promise< { result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> {
    if(!this._inbound_services_storage_complete) { 
      this._inbound_services_storage_complete = this.injector.get(MovuRobotics_inbound_services_storage_completeService);
    }
    return this._inbound_services_storage_complete.run($inParams);
  }
   
   

   
 
  private _main_outbound_transactions_auto_flag_for_retry: MovuRobotics_main_outbound_transactions_auto_flag_for_retryService;
  public async main_outbound_transactions_auto_flag_for_retry($inParams: {  }): Promise< { outputDetails?: string[] }> {
    if(!this._main_outbound_transactions_auto_flag_for_retry) { 
      this._main_outbound_transactions_auto_flag_for_retry = this.injector.get(MovuRobotics_main_outbound_transactions_auto_flag_for_retryService);
    }
    return this._main_outbound_transactions_auto_flag_for_retry.run($inParams);
  }
   
   

   
 
  private _main_outbound_transactions_retry: MovuRobotics_main_outbound_transactions_retryService;
  public async main_outbound_transactions_retry($inParams: {  }): Promise< { outputDetails?: string[] }> {
    if(!this._main_outbound_transactions_retry) { 
      this._main_outbound_transactions_retry = this.injector.get(MovuRobotics_main_outbound_transactions_retryService);
    }
    return this._main_outbound_transactions_retry.run($inParams);
  }
   
   

   
 
  private _map_activate_container_request_payload: MovuRobotics_map_activate_container_request_payloadService;
  public async map_activate_container_request_payload($inParams: { loadContainerId: number, locationId: number, storageTransactionId?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.ShipmentDetails }> {
    if(!this._map_activate_container_request_payload) { 
      this._map_activate_container_request_payload = this.injector.get(MovuRobotics_map_activate_container_request_payloadService);
    }
    return this._map_activate_container_request_payload.run($inParams);
  }
   
   

   
 
  private _map_activate_shipment_by_shipids: MovuRobotics_map_activate_shipment_by_shipidsService;
  public async map_activate_shipment_by_shipids($inParams: {  }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.ActivationDetails }> {
    if(!this._map_activate_shipment_by_shipids) { 
      this._map_activate_shipment_by_shipids = this.injector.get(MovuRobotics_map_activate_shipment_by_shipidsService);
    }
    return this._map_activate_shipment_by_shipids.run($inParams);
  }
   
   

   
 
  private _map_alter_pallet_hold_release_request_payload: MovuRobotics_map_alter_pallet_hold_release_request_payloadService;
  public async map_alter_pallet_hold_release_request_payload($inParams: { taskId: number, storageTransactionId?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.HoldReleasePalletRequests }> {
    if(!this._map_alter_pallet_hold_release_request_payload) { 
      this._map_alter_pallet_hold_release_request_payload = this.injector.get(MovuRobotics_map_alter_pallet_hold_release_request_payloadService);
    }
    return this._map_alter_pallet_hold_release_request_payload.run($inParams);
  }
   
   

   
 
  private _map_change_shipment_request_payload: MovuRobotics_map_change_shipment_request_payloadService;
  public async map_change_shipment_request_payload($inParams: { shipmentId: number, orderId?: number, storageTransactionId?: string, changeContext?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.ShipmentDetails }> {
    if(!this._map_change_shipment_request_payload) { 
      this._map_change_shipment_request_payload = this.injector.get(MovuRobotics_map_change_shipment_request_payloadService);
    }
    return this._map_change_shipment_request_payload.run($inParams);
  }
   
   

   
 
  private _map_pallet_induction_request_payload: MovuRobotics_map_pallet_induction_request_payloadService;
  public async map_pallet_induction_request_payload($inParams: { licensePlateId?: number, taskId?: number, storageTransactionId?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.PalletInduction }> {
    if(!this._map_pallet_induction_request_payload) { 
      this._map_pallet_induction_request_payload = this.injector.get(MovuRobotics_map_pallet_induction_request_payloadService);
    }
    return this._map_pallet_induction_request_payload.run($inParams);
  }
   
   

   
 
  private _map_pallet_request_details: MovuRobotics_map_pallet_request_detailsService;
  public async map_pallet_request_details($inParams: { taskId?: number }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.PalletRequestDetails }> {
    if(!this._map_pallet_request_details) { 
      this._map_pallet_request_details = this.injector.get(MovuRobotics_map_pallet_request_detailsService);
    }
    return this._map_pallet_request_details.run($inParams);
  }
   
   

   
 
  private _map_pick_request_details: MovuRobotics_map_pick_request_detailsService;
  public async map_pick_request_details($inParams: { taskId?: number }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.PalletRequestDetails }> {
    if(!this._map_pick_request_details) { 
      this._map_pick_request_details = this.injector.get(MovuRobotics_map_pick_request_detailsService);
    }
    return this._map_pick_request_details.run($inParams);
  }
   
   

   
 
  private _map_shipment_download_request_payload: MovuRobotics_map_shipment_download_request_payloadService;
  public async map_shipment_download_request_payload($inParams: { shipmentId: number, orderId?: number, storageTransactionId?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.ShipmentDetails }> {
    if(!this._map_shipment_download_request_payload) { 
      this._map_shipment_download_request_payload = this.injector.get(MovuRobotics_map_shipment_download_request_payloadService);
    }
    return this._map_shipment_download_request_payload.run($inParams);
  }
   
   

   
 
  private _pallet_induction_on_success: MovuRobotics_pallet_induction_on_successService;
  public async pallet_induction_on_success($inParams: { licensePlateId?: number, locationId?: number, warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._pallet_induction_on_success) { 
      this._pallet_induction_on_success = this.injector.get(MovuRobotics_pallet_induction_on_successService);
    }
    return this._pallet_induction_on_success.run($inParams);
  }
   
   

   
 
  private _pallet_request_on_success: MovuRobotics_pallet_request_on_successService;
  public async pallet_request_on_success($inParams: { warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._pallet_request_on_success) { 
      this._pallet_request_on_success = this.injector.get(MovuRobotics_pallet_request_on_successService);
    }
    return this._pallet_request_on_success.run($inParams);
  }
   
   

   
 
  private _pick_confirmation_on_failure: MovuRobotics_pick_confirmation_on_failureService;
  public async pick_confirmation_on_failure($inParams: { Task_id?: string, wh_id?: string, Srcloc?: string, Pallet_id?: string, Success?: any, error_message?: string }): Promise< { reason?: string }> {
    if(!this._pick_confirmation_on_failure) { 
      this._pick_confirmation_on_failure = this.injector.get(MovuRobotics_pick_confirmation_on_failureService);
    }
    return this._pick_confirmation_on_failure.run($inParams);
  }
   
   

   
 
  private _pick_request_on_failure: MovuRobotics_pick_request_on_failureService;
  public async pick_request_on_failure($inParams: { warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise< { reason?: string }> {
    if(!this._pick_request_on_failure) { 
      this._pick_request_on_failure = this.injector.get(MovuRobotics_pick_request_on_failureService);
    }
    return this._pick_request_on_failure.run($inParams);
  }
   
   

   
 
  private _pick_request_on_success: MovuRobotics_pick_request_on_successService;
  public async pick_request_on_success($inParams: { warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._pick_request_on_success) { 
      this._pick_request_on_success = this.injector.get(MovuRobotics_pick_request_on_successService);
    }
    return this._pick_request_on_success.run($inParams);
  }
   
   

   
 
  private _pick_request_processor: MovuRobotics_pick_request_processorService;
  public async pick_request_processor($inParams: { taskId?: number, warehouseId?: number }): Promise<void> {
    if(!this._pick_request_processor) { 
      this._pick_request_processor = this.injector.get(MovuRobotics_pick_request_processorService);
    }
    return this._pick_request_processor.run($inParams);
  }
   
   

   
 
  private _save_configuration_by_environment_warehouse: MovuRobotics_save_configuration_by_environment_warehouseService;
  public async save_configuration_by_environment_warehouse($inParams: { application_name: string, environment: string, warehouseId: number, Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Auth_Authorization?: string, Auth_TokenUrl?: string, Auth_Scope?: string, Auth_GrantType?: string, Auth_ClientId?: string, Auth_ClientSecret?: string, Auth_Username?: string, Auth_Password?: string, Service_PickRequest?: string }): Promise< { Endpoint?: string, Port?: string, Username?: string, Password?: string, ApiKey?: string, ApiSecret?: string, debugDetails?: string[], Service_PalletInduction?: string, Service_ShipmentDownload?: string, Service_ActivateContainer?: string, Service_AdjustSalesOrder?: string, Service_PalletRequest?: string, Service_InventoryAdjustRequest?: string, Service_AlterPalletRequest?: string, Service_ChangeShipmentRequest?: string, Service_PickRequest?: string }> {
    if(!this._save_configuration_by_environment_warehouse) { 
      this._save_configuration_by_environment_warehouse = this.injector.get(MovuRobotics_save_configuration_by_environment_warehouseService);
    }
    return this._save_configuration_by_environment_warehouse.run($inParams);
  }
   
   

   
 
  private _send_alert_to_footprint_legacy: MovuRobotics_send_alert_to_footprint_legacyService;
  public async send_alert_to_footprint_legacy($inParams: { alertMessage: string, alertDetails: string }): Promise<void> {
    if(!this._send_alert_to_footprint_legacy) { 
      this._send_alert_to_footprint_legacy = this.injector.get(MovuRobotics_send_alert_to_footprint_legacyService);
    }
    return this._send_alert_to_footprint_legacy.run($inParams);
  }
   
   

   
 
  private _send_http_request: MovuRobotics_send_http_requestService;
  public async send_http_request($inParams: { payload: string, messageTransactionId: string, warehouseId: number, executionContext: $frontendTypes.MovuRobotics.OperationTypes }): Promise< { responseResult?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> {
    if(!this._send_http_request) { 
      this._send_http_request = this.injector.get(MovuRobotics_send_http_requestService);
    }
    return this._send_http_request.run($inParams);
  }
   
   

   
 
  private _shipment_download_on_success: MovuRobotics_shipment_download_on_successService;
  public async shipment_download_on_success($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._shipment_download_on_success) { 
      this._shipment_download_on_success = this.injector.get(MovuRobotics_shipment_download_on_successService);
    }
    return this._shipment_download_on_success.run($inParams);
  }
   
   

   
 
  private _testing_the_is_defined_function: MovuRobotics_testing_the_is_defined_functionService;
  public async testing_the_is_defined_function($inParams: {  }): Promise< { results?: any[] }> {
    if(!this._testing_the_is_defined_function) { 
      this._testing_the_is_defined_function = this.injector.get(MovuRobotics_testing_the_is_defined_functionService);
    }
    return this._testing_the_is_defined_function.run($inParams);
  }
   
   

   
}
